module.exports = __webpack_public_path__ + "img/portable-speaker-3.34449dda.png";